


































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrBiduiPreviewWenli extends Vue {
  @Prop()
  private message: any;
}
